export default function Notifications() {
  return (
    <div className="card">
      <div className="card-body">
        <h4 className="mb-3">การแจ้งเตือน</h4>
        <p className="text-muted">ตั้งค่าการแจ้งเตือนอีเมล/ในระบบสำหรับคำสั่งซื้อและข่าวสาร</p>
      </div>
    </div>
  );
}
